import CompanyDetailsCard from "./CompanyDetailsCard";

export default CompanyDetailsCard;
